'use client';

import type { FC } from 'react';
import parse from 'html-react-parser';
import Image from 'next/image';

import { cn } from '@/lib/utils';

import { Card } from '@/components/atoms/Card';
import { P } from '@/components/atoms/Typography/P';
import { Title } from '@/components/atoms/Typography/Title';

import type { OpinionCardTemplateProps } from './OpinionCardTemplate.types';

const OpinionCardTemplate: FC<OpinionCardTemplateProps> = ({
    heading,
    content,
    image,
    className,
    ...cardProps
}) => (
    <Card
        size="l"
        variant="shadow"
        className={cn(
            'mx-1 my-4 flex h-full w-fit max-w-[320px] flex-col justify-between gap-4 self-stretch lg:m-0 lg:max-w-full',
            className,
        )}
        {...cardProps}
    >
        <Title size="m">{heading}</Title>

        <P className={'self-stretch text-grey-600'}>{parse(content)}</P>

        <Image
            src={image.src}
            alt={image.alt}
            height={24}
            width={104}
            className="my-2"
        />
    </Card>
);

export default OpinionCardTemplate;
